import { AnyAction, applyMiddleware, createStore, Middleware, Reducer } from 'redux';

export default function createComposedStore(
  reducers: Reducer<any, AnyAction>,
  middlewares: Middleware[],
) {
  const enhancer = applyMiddleware(...middlewares);
  return createStore(reducers, enhancer);
}
